import { Link } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import Logo from "../../../assets/icons/Logo.svg?react";
import { Button } from "../../../components/Button";
import { WEBSITE_URL } from "../../../env";

export function Header({
  showSignIn = false,
  showSignUp = false,
  isProvider = false,
}) {
  return (
    <div className="px-4 md:px-10 py-4 bg-white/[0.64] backdrop-blur-[27px] border-b border-black/10 justify-between items-center flex">
      <div className=" justify-center items-center flex">
        <a href={`${WEBSITE_URL}`} rel="noreferrer">
          <Logo />
        </a>
      </div>
      <div className="justify-start items-start gap-3 flex">
        {/* Phone pill - hidden on mobile, shows as icon on mobile */}
        <a
          href="tel:4783476197"
          className="hidden md:flex bg-secondary px-5 py-2 rounded-[40px] border text-darkText text-center text-xs sm:text-base font-medium hover:bg-secondary/80 transition-colors"
        >
          Questions? Call
          <span className="text-primary text-xs sm:text-base font-bold leading-snug ml-1">
            (478) 347-6197
          </span>
        </a>
        
        {/* Phone icon - visible only on mobile */}
        <a
          href="tel:4783476197"
          className="md:hidden flex items-center justify-center w-10 h-10 bg-secondary rounded-full border hover:bg-secondary/80 transition-colors"
        >
          <FontAwesomeIcon icon={faPhone} className="text-primary text-sm" />
        </a>

        {showSignIn && (
          <Link to="/login">
            <Button
              variant="primary"
              className="px-4 py-2 !rounded-full bg-primary justify-center items-center gap-2.5 flex"
            >
              Sign In
            </Button>
          </Link>
        )}

        {showSignUp && (
          <a
            href="/register"
          >
            <Button
              variant="primary"
              className="px-4 py-2 !rounded-full bg-primary justify-center items-center gap-2.5 flex"
            >
              Sign Up
            </Button>
          </a>
        )}
      </div>
    </div>
  );
}
